import axios from "axios";
import { SUPPLEMENT_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";

interface Payload {
  name?: string;
  price?: number;
  category?: string;
  description?: string;
  benefits?: string[];
  thumbnail: string | null;
}

export const getProducts = async () => {
  const api = axiosAuth();

  const res = await api.get(`${SUPPLEMENT_BASE_URL}/products?limit=150`);

  return res?.data.data.results ?? [];
};

export const addProduct = async (payload: Payload) => {
    const res = await axios.post(`${SUPPLEMENT_BASE_URL}/products`, payload);

    return res?.data.data.product;
};

export const uploadProductThumbnail = async (file: File) => {
  if (!file) return;

  try {
    const res = await axios.get(
      `${SUPPLEMENT_BASE_URL}/upload?file=${file.name}`,
    );

    if (res?.status === 200) {
      const url = res?.data.data.url;
      const key = res?.data.data.Key;

      await axios.put(url, file);

      return key;
    }
  } catch (error) {
    console.log(error, "Thumbnail Upload Failed.");
  }
};

export const updateProduct = async (payload, id: string) => {
  
    const res = await axios.put(
      `${SUPPLEMENT_BASE_URL}/products/${id}`,
      payload,
    );

    return res.data;
};

export const deleteProduct = async (id: string) => {
  try {
    const res = await axios.delete(`${SUPPLEMENT_BASE_URL}/product/${id}`);

    return res.data;
  } catch (error) {
    console.log("failed to delete product", error);
  }
};

// export const ApiService = async (method: string, endpoint: string, id: string) => {
//   try {
//     const res = await axios.method(`${SUPPLEMENT_BASE_URL}/${endpoint}/${id}`);

//     return res.data;

//   } catch (error) {
//     console.error(error);
//   }
// }
